import React from "react";
import SvgIcon from "../../../../../parts/SvgIcon";

// Both goal columns in PhaseSummary.js (Daily Targets, Custom Goals) share
// this exact empty-state shape (title + count chip + description + CTA) -
// lives here once instead of being written twice with only the strings
// swapped.
export const GoalsEmptyState = ({
  title,
  chipLabel,
  description,
  ctaLabel,
  onCta,
}) => (
  <div className="summary-goals-empty">
    <div className="summary-goals-empty-heading">
      <span className="summary-goals-empty-title">{title}</span>
      <span className="summary-goals-empty-chip">{chipLabel}</span>
    </div>
    <p className="summary-goals-empty-description">{description}</p>
    <button
      type="button"
      data-button-type="outline"
      className="summary-goals-empty-cta"
      onClick={onCta}
    >
      <SvgIcon
        src="/img/new-icons/add-28.svg"
        useCurrentColor
        classNames="icon-sm"
      />
      {/* [data-button-type="outline"] is `color: transparent` + a gradient
          background-clip by default (semantic.css's `.clipped`, for a
          gradient-text look) - a `<span>` label is what semantic.css looks
          for to move that clip onto just the text, leaving the button (and
          this icon, which reads `currentColor`) normal instead of also
          transparent. Bare text here rendered fully invisible. */}
      <span>{ctaLabel}</span>
    </button>
  </div>
);

// Same CTA button as above, standalone - shown next to an already-filled
// goal column (Daily Targets/Custom Goals in PhaseSummary.js) instead of
// inside the empty state, so a coach can keep adding more without the
// column ever running out of a way back into the add flow. Each caller
// supplies its own condition for when to render this (e.g. Daily Targets
// only hides it once all 3 types are set) and its own onCta (different
// modal per column).
export const GoalsAddButton = ({ ctaLabel, onCta }) => (
  <button
    type="button"
    data-button-type="outline"
    className="summary-goals-empty-cta"
    onClick={onCta}
  >
    <SvgIcon
      src="/img/new-icons/add-28.svg"
      useCurrentColor
      classNames="icon-sm"
    />
    <span>{ctaLabel}</span>
  </button>
);
